import React, { useEffect, useState } from 'react';
import useTooth from '../../Hooks/Tooth/useTooth';
import {
	ToothRestoration,
	ToothRestorationDetail,
	ToothRestorationMaterial,
	ToothRestorationQuality,
} from '../../../../graphql/graphql';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';

const DENTModalOverviewRestorationVeneer = () => {
	const { restoration } = useTooth();

	const [values, setValues] = useState<ToothRestoration | undefined>(
		restoration.data,
	);

	useEffect(() => {
		setValues(restoration.data);
	}, [restoration.data?.type]);

	useEffect(() => {
		if (values) {
			restoration.setRestoration(values);
		}
	}, [values]);

	const handleChangeMaterial = (value: ToothRestorationMaterial) => {
		setValues(prev => {
			return prev?.material === value
				? {
						material: undefined,
						quality: undefined,
						detail: undefined,
				  }
				: { ...prev, material: value };
		});
	};

	const handleChangeQuality = (value: ToothRestorationQuality) => {
		setValues(prev => {
			return prev?.quality === value
				? {
						quality: undefined,
						detail: undefined,
				  }
				: { ...prev, quality: value };
		});
	};

	const handleChangeDetail = (value: ToothRestorationDetail) => {
		setValues(prev => ({
			...prev,
			detail: prev?.detail === value ? undefined : value,
		}));
	};

	const rows = [
		{
			shouldHide: false,
			title:
				'patientTreatment.meddiDENT.dentalCross.restorationModal.material.title',
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.material.composite',
					isSelected: values?.material === ToothRestorationMaterial.Composite,
					onClick: () =>
						handleChangeMaterial(ToothRestorationMaterial.Composite),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.material.ceramic',
					isSelected: values?.material === ToothRestorationMaterial.Ceramic,
					onClick: () => handleChangeMaterial(ToothRestorationMaterial.Ceramic),
				},
			],
		},
		{
			shouldHide: !values?.material,
			title:
				'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.title',
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.sufficient',
					isSelected: values?.quality === ToothRestorationQuality.Sufficient,
					onClick: () =>
						handleChangeQuality(ToothRestorationQuality.Sufficient),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.uncertain',
					isSelected: values?.quality === ToothRestorationQuality.Uncertain,
					onClick: () => handleChangeQuality(ToothRestorationQuality.Uncertain),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.quality.insufficient',
					isSelected: values?.quality === ToothRestorationQuality.Insufficient,
					onClick: () =>
						handleChangeQuality(ToothRestorationQuality.Insufficient),
				},
			],
		},
		{
			shouldHide: !(values?.material && values?.quality),
			title:
				'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.title',
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.overhang',
					isSelected: values?.detail === ToothRestorationDetail.Overhang,
					onClick: () => handleChangeDetail(ToothRestorationDetail.Overhang),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.flush',
					isSelected: values?.detail === ToothRestorationDetail.Flush,
					onClick: () => handleChangeDetail(ToothRestorationDetail.Flush),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.restorationModal.detail.shortfall',
					isSelected: values?.detail === ToothRestorationDetail.Shortfall,
					onClick: () => handleChangeDetail(ToothRestorationDetail.Shortfall),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewRestorationVeneer;
